import React, { useEffect } from 'react';
import styles from './NoMatch.module.scss';
import { reportBusinessActionToMixpanel } from '../../../utils/reportBusinessActionToMixpanel';
import { useMixpanel } from 'react-mixpanel-browser';

function NoMatch() {
  const mixpanel = useMixpanel();

  useEffect(() => {
    reportBusinessActionToMixpanel(mixpanel, 'page-not-found', { href: window.location.href });
  }, [mixpanel]);

  return (
    <div className={styles.container}>
      <h1>Page not found</h1>
    </div>
  );
}

export default NoMatch;
